import React, { useEffect } from "react";
import { Col, Row, Select, Form, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoginOptions, createLoginOptions } from "./redux/actions";

const { Option } = Select;

const loginOptionsInputs = [
  { label: "SSO", value: "sso" },
  { label: "Email/Password", value: "emailpassword" },
  { label: "Google/Apple", value: "google/apple" },
  { label: "Microsoft", value: "microsoft" },
];

const LoginOptionTable = () => {
  const { loginOption = null } = useSelector(
    (state) => state.loginOptionReducer
  );

  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    if (loginOption) {
      const { login_details } = loginOption?.config;
      Object.entries(login_details).forEach(([key, value]) => {
        form.setFieldValue(key, value.force_redirect);
      });
    }
  }, [loginOption]);

  useEffect(() => {
    dispatch(fetchLoginOptions());
  }, []);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      const login_details = {
        student: {
          force_redirect: values.student || null,
        },
        teacher: {
          force_redirect: values.teacher || null,
        },
        guardian: {
          force_redirect: values.guardian || null,
        },
        tutor: {
          force_redirect: values.tutor || null,
        },
      };

      dispatch(createLoginOptions(login_details));
    } catch (errorInfo) {
      console.log("Validation failed:", errorInfo);
    }
  };

  return (
    <div className="page-top-div">
      <span className="text-span">Login Option</span>

      <Row justify="center" className="production-manager-parent-row">
        <Col span={24} className="heading-col">
          <Row align="middle" justify="space-between">
            <Col>
              <span className="heading-span">Login Option Register</span>
            </Col>
          </Row>
        </Col>

        <Col md={24} lg={23} xl={20} xxl={20} style={{ minHeight: "10vh" }}>
          <Form form={form} layout="vertical">
            <Row gutter={[16, 0]}>
              {/* <Col span={12}>
                <div className="special-table-header-text">Student</div>
                <Form.Item
                  name="student"
                  rules={[{ required: true, message: "Required!" }]}
                >
                  <Select
                    mode="multiple"
                    size="small"
                    allowClear
                    showSearch
                    placeholder="Select types"
                    optionLabelProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownClassName="select-dropdown-custom"
                    getPopupContainer={() =>
                      document.getElementsByClassName(
                        "ant-layout-content layout-content site-layout-background custom-textarea"
                      )[0]
                    }
                  >
                    {loginOptions.map(({ label, value }) => (
                      <Option key={value} value={value} label={label}>
                        {label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <div className="special-table-header-text">Teacher</div>
                <Form.Item
                  name="teacher"
                  rules={[{ required: true, message: "Required!" }]}
                >
                  <Select
                    mode="multiple"
                    size="small"
                    allowClear
                    showSearch
                    placeholder="Select types"
                    optionLabelProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownClassName="select-dropdown-custom"
                    getPopupContainer={() =>
                      document.getElementsByClassName(
                        "ant-layout-content layout-content site-layout-background custom-textarea"
                      )[0]
                    }
                  >
                    {loginOptions.map(({ label, value }) => (
                      <Option key={value} value={value} label={label}>
                        {label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <div className="special-table-header-text">Guardian</div>
                <Form.Item
                  name="guardian"
                  rules={[{ required: true, message: "Required!" }]}
                >
                  <Select
                    mode="multiple"
                    size="small"
                    allowClear
                    showSearch
                    placeholder="Select types"
                    optionLabelProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownClassName="select-dropdown-custom"
                    getPopupContainer={() =>
                      document.getElementsByClassName(
                        "ant-layout-content layout-content site-layout-background custom-textarea"
                      )[0]
                    }
                  >
                    {loginOptions.map(({ label, value }) => (
                      <Option key={value} value={value} label={label}>
                        {label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <div className="special-table-header-text">Tutor</div>
                <Form.Item
                  name="tutor"
                  rules={[{ required: true, message: "Required!" }]}
                >
                  <Select
                    mode="multiple"
                    size="small"
                    allowClear
                    showSearch
                    placeholder="Select types"
                    optionLabelProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownClassName="select-dropdown-custom"
                    getPopupContainer={() =>
                      document.getElementsByClassName(
                        "ant-layout-content layout-content site-layout-background custom-textarea"
                      )[0]
                    }
                  >
                    {loginOptions.map(({ label, value }) => (
                      <Option key={value} value={value} label={label}>
                        {label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col> */}

              {/* <Col span={24}>
                <div className="special-table-header-text">Force Re-direct</div>
                <Form.Item name="force">
                  <Select
                    mode="multiple"
                    size="small"
                    allowClear
                    showSearch
                    placeholder="Select types"
                    optionLabelProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownClassName="select-dropdown-custom"
                    getPopupContainer={() =>
                      document.getElementsByClassName(
                        "ant-layout-content layout-content site-layout-background custom-textarea"
                      )[0]
                    }
                  >
                    {loginOptions.map(({ label, value }) => (
                      <Option key={value} value={value} label={label}>
                        {label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col> */}

              <Col span={12}>
                <div className="special-table-header-text">
                  Student Force Re-direct
                </div>
                <Form.Item name="student">
                  <Select
                    size="small"
                    allowClear
                    showSearch
                    placeholder="Select types"
                    optionLabelProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownClassName="select-dropdown-custom"
                    getPopupContainer={() =>
                      document.getElementsByClassName(
                        "ant-layout-content layout-content site-layout-background custom-textarea"
                      )[0]
                    }
                  >
                    {loginOptionsInputs.map(({ label, value }) => (
                      <Option key={value} value={value} label={label}>
                        {label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <div className="special-table-header-text">
                  {" "}
                  Teacher Force Re-direct
                </div>
                <Form.Item name="teacher">
                  <Select
                    size="small"
                    allowClear
                    showSearch
                    placeholder="Select types"
                    optionLabelProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownClassName="select-dropdown-custom"
                    getPopupContainer={() =>
                      document.getElementsByClassName(
                        "ant-layout-content layout-content site-layout-background custom-textarea"
                      )[0]
                    }
                  >
                    {loginOptionsInputs.map(({ label, value }) => (
                      <Option key={value} value={value} label={label}>
                        {label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <div className="special-table-header-text">
                  Guardian Force Re-direct
                </div>
                <Form.Item name="guardian">
                  <Select
                    size="small"
                    allowClear
                    showSearch
                    placeholder="Select types"
                    optionLabelProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownClassName="select-dropdown-custom"
                    getPopupContainer={() =>
                      document.getElementsByClassName(
                        "ant-layout-content layout-content site-layout-background custom-textarea"
                      )[0]
                    }
                  >
                    {loginOptionsInputs.map(({ label, value }) => (
                      <Option key={value} value={value} label={label}>
                        {label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <div className="special-table-header-text">
                  Tutor Force Re-direct
                </div>
                <Form.Item name="tutor">
                  <Select
                    size="small"
                    allowClear
                    showSearch
                    placeholder="Select types"
                    optionLabelProp="label"
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownClassName="select-dropdown-custom"
                    getPopupContainer={() =>
                      document.getElementsByClassName(
                        "ant-layout-content layout-content site-layout-background custom-textarea"
                      )[0]
                    }
                  >
                    {loginOptionsInputs.map(({ label, value }) => (
                      <Option key={value} value={value} label={label}>
                        {label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col>
                <Button htmlType="primary" onClick={handleSave}>
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default LoginOptionTable;
